//
import { MaterialIcons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import colors from '../../colors';
import { HEADER_HEIGHT, TXT_GG } from '../../constants';
import Touchable from './Touchable';

type Props = {
  titulo?: string;
  goBack?: boolean;
  openMenu?: () => void;
};

const Header: React.FC<Props> = (props) => {
  const { titulo, goBack, openMenu } = props;
  const navigation = useNavigation();

  return (
    <View>
      <View style={styles.header}>
        {goBack && (
          <Touchable onPress={() => navigation.goBack()} style={styles.button}>
            <MaterialIcons name="arrow-back" size={30} color="#fff" />
          </Touchable>
        )}

        {openMenu && (
          <Touchable onPress={() => openMenu()} style={styles.button}>
            <MaterialIcons name="menu" size={30} color="#fff" />
          </Touchable>
        )}

        {!goBack && !openMenu && <View style={styles.button} />}

        <View style={styles.titleView}>
          {titulo !== undefined ? (
            <View style={{ width: '100%' }}>
              <Text style={styles.title}>{titulo}</Text>
            </View>
          ) : (
            <Image
              source={require('../../../assets/cardapp-letras-2.png')}
              style={{
                width: '100%',
                height: HEADER_HEIGHT - 15,
                resizeMode: 'contain'
              }}
            />
          )}
        </View>
        <Touchable onPress={() => {}} style={styles.button}></Touchable>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    height: HEADER_HEIGHT,
    backgroundColor: colors.drawer,
    width: '100%',
    flexDirection: 'row'
  },
  button: { height: HEADER_HEIGHT, width: 70, alignItems: 'center', justifyContent: 'center' },
  titleView: { flex: 1, justifyContent: 'center', alignItems: 'center' },
  title: { fontSize: TXT_GG, color: '#fff', fontWeight: '500' }
});

export default Header;
